const layoutTransPath = 'mainLayout.dialog.';
const layoutBtnTransPath = 'button.';
const dpnTransPath = layoutTransPath + 'dpn.';
const termsTransPath = 'onboard.terms.';

 const layoutTranslations = {
    LOGOUT_DIALOG_TITLE: layoutTransPath + "title",
    LOGOUT_DESCRIPTION: layoutTransPath + "description",

    PRIVACY_TITLE: layoutTransPath + "footer.privacy",
    TERMS_TITLE: layoutTransPath + "footer.terms",

    DPN_DESCRIPTION:dpnTransPath + "description",
    DPN_PAGE_LINK:dpnTransPath + "pageLink",
    
    TERMS_DESCRIPTION: termsTransPath + 'description',

    CANCEL_AND_STAY_BTN_LABEL: layoutBtnTransPath + "cancelAndStay",
    LOGOUT_BTN_LABEL: layoutBtnTransPath + "logout",
    CLOSE_BTN : layoutBtnTransPath + "close"
}

export default layoutTranslations